import 'svelte/internal/disclose-version';

ReviewForm[$.FILENAME] = 'src/components/ReviewForm.svelte';

import * as $ from 'svelte/internal/client';
import Field from "./Field.svelte";
import api from "../lib/api.js";
import { session } from "../lib/session.svelte.js";
import { toastError, toastSuccess } from "../lib/toast.svelte.js";

var root = $.add_locations($.from_html(`<button type="button" role="radio">★</button>`), ReviewForm[$.FILENAME], [[62, 8]]);
var root_1 = $.add_locations($.from_html(`<p class="error svelte-m1g7qe"> </p>`), ReviewForm[$.FILENAME], [[86, 13]]);
var root_2 = $.add_locations($.from_html(`<span class="note svelte-m1g7qe">Posting as a guest — <a href="/login" class="svelte-m1g7qe">log in</a> to edit it later.</span>`), ReviewForm[$.FILENAME], [[93, 6, [[93, 46]]]]);

var root_3 = $.add_locations($.from_html(`<form class="review-form svelte-m1g7qe"><h3 class="svelte-m1g7qe"> </h3> <div class="rating svelte-m1g7qe"><div class="stars svelte-m1g7qe" role="radiogroup" tabindex="-1" aria-label="Your rating"></div> <span class="word svelte-m1g7qe"> </span></div> <!> <!> <!> <!> <div class="actions svelte-m1g7qe"><button type="submit" class="primary svelte-m1g7qe"> </button> <!></div></form>`), ReviewForm[$.FILENAME], [
	[
		50,
		0,
		[[51, 2], [53, 2, [[54, 4], [76, 4]]], [88, 2, [[89, 4]]]]
	]
]);

const $$css = {
	hash: 'svelte-m1g7qe',
	code: '\n  .review-form.svelte-m1g7qe {\n    background: var(--card);\n    border: 1px solid var(--line);\n    border-radius: var(--radius-lg);\n    padding: 22px;\n    display: flex;\n    flex-direction: column;\n    gap: 14px;\n  }\n  h3.svelte-m1g7qe { font-size: 1.1rem; }\n\n  .rating.svelte-m1g7qe { display: flex; align-items: center; gap: 12px; flex-wrap: wrap; }\n  .stars.svelte-m1g7qe { display: flex; gap: 2px; }\n  .stars.svelte-m1g7qe button:where(.svelte-m1g7qe) {\n    border: none;\n    background: none;\n    font-size: 1.9rem;\n    line-height: 1;\n    cursor: pointer;\n    color: var(--line-strong);\n    padding: 0 2px;\n    transition: color 0.12s ease, transform 0.12s ease;\n  }\n  .stars.svelte-m1g7qe button.on:where(.svelte-m1g7qe) { color: var(--mustard); }\n  .stars.svelte-m1g7qe button:where(.svelte-m1g7qe):hover { transform: scale(1.12); }\n  .word.svelte-m1g7qe { font-size: 0.88rem; color: var(--ink-soft); }\n\n  .actions.svelte-m1g7qe { display: flex; align-items: center; gap: 14px; flex-wrap: wrap; }\n  .primary.svelte-m1g7qe {\n    background: var(--accent);\n    color: #fff;\n    border: none;\n    font-weight: 600;\n    font-size: 0.92rem;\n    padding: 11px 22px;\n    border-radius: var(--radius-pill);\n    cursor: pointer;\n  }\n  .primary.svelte-m1g7qe:hover:not(:disabled) { background: var(--accent-dark); }\n  .primary.svelte-m1g7qe:disabled { opacity: 0.6; cursor: progress; }\n\n  .note.svelte-m1g7qe { font-size: 0.82rem; color: var(--ink-faint); }\n  .note.svelte-m1g7qe a:where(.svelte-m1g7qe) { color: var(--accent); font-weight: 600; }\n  .error.svelte-m1g7qe { margin: 0; color: var(--accent-dark); font-size: 0.86rem; }\n\n/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */'
};

export default function ReviewForm($$anchor, $$props) {
	$.check_target(new.target);
	$.push($$props, true, ReviewForm);
	$.append_styles($$anchor, $$css);

	let existing = $.prop($$props, 'existing', 3, null),
		onsaved = $.prop($$props, 'onsaved', 3, null);

	let rating = $.tag($.state($.proxy(existing()?.rating ?? 0)), 'rating');
	let hovered = $.tag($.state(0), 'hovered');
	let title = $.tag($.state($.proxy(existing()?.title ?? "")), 'title');
	let body = $.tag($.state($.proxy(existing()?.body ?? "")), 'body');
	let authorName = $.tag($.state(""), 'authorName');
	let busy = $.tag($.state(false), 'busy');
	let error = $.tag($.state(""), 'error');
	const shown = $.tag($.derived(() => $.get(hovered) || $.get(rating)), 'shown');

	const words = [
		"",
		"Not for me",
		"It was okay",
		"Pretty good",
		"Really good",
		"A neighbourhood gem"
	];

	async function submit(event) {
		event.preventDefault();
		$.set(error, "");

		if ($.get(rating) < 1) {
			$.set(error, "Pick a star rating first.");

			return;
		}

		$.set(busy, true);

		try {
			const saved = (await $.track_reactivity_loss(api.postReview($$props.slug, {
				rating: $.get(rating),
				title: $.get(title).trim(),
				body: $.get(body).trim(),
				authorName: session.user ? undefined : $.get(authorName).trim()
			})))();

			toastSuccess(existing() ? "Your review is updated." : "Thanks for sharing!");
			onsaved()?.(saved);

			if (!existing()) {
				$.set(title, "");
				$.set(body, "");
			}
		} catch(e) {
			$.set(error, e.message ?? "Couldn't post that review.", true);
			toastError($.get(error));
		} finally {
			$.set(busy, false);
		}
	}

	var $$exports = { ...$.legacy_api() };
	var form = root_3();
	var h3 = $.child(form);
	var text = $.child(h3, true);

	$.reset(h3);

	var div = $.sibling(h3, 2);
	var div_1 = $.child(div);

	$.add_svelte_meta(
		() => $.each(div_1, 20, () => [1, 2, 3, 4, 5], (star) => star, ($$anchor, star) => {
			var button = root();
			let classes;

			$.template_effect(() => {
				$.set_attribute(button, 'aria-checked', $.strict_equals($.get(rating), star));
				$.set_attribute(button, 'aria-label', `${star ?? ''} star${$.strict_equals(star, 1) ? '' : 's'}`);
				classes = $.set_class(button, 1, 'svelte-m1g7qe', null, classes, { on: $.get(shown) >= star });
			});

			$.event('mouseenter', button, function mouseenter() {
				return $.set(hovered, star, true);
			});

			$.event('focus', button, function focus() {
				return $.set(hovered, star, true);
			});

			$.delegated('click', button, function click() {
				return $.set(rating, star, true);
			});

			$.append($$anchor, button);
		}),
		'each',
		ReviewForm,
		61,
		6
	);

	$.reset(div_1);

	var span = $.sibling(div_1, 2);
	var text_1 = $.child(span, true);

	$.reset(span);
	$.reset(div);

	var node = $.sibling(div, 2);

	{
		var consequent = ($$anchor) => {
			$.add_svelte_meta(
				() => Field($$anchor, {
					label: 'Your name',
					name: 'authorName',
					placeholder: 'Sam from two doors down',
					required: true,
					get value() {
						return $.get(authorName);
					},

					set value($$value) {
						$.set(authorName, $$value, true);
					}
				}),
				'component',
				ReviewForm,
				80,
				4,
				{ componentTag: 'Field' }
			);
		};

		$.add_svelte_meta(
			() => $.if(node, ($$render) => {
				if (!session.user) $$render(consequent);
			}),
			'if',
			ReviewForm,
			79,
			2
		);
	}

	var node_1 = $.sibling(node, 2);

	$.add_svelte_meta(
		() => Field(node_1, {
			label: 'Headline',
			name: 'title',
			placeholder: 'Optional — a one-line summary',
			get value() {
				return $.get(title);
			},

			set value($$value) {
				$.set(title, $$value, true);
			}
		}),
		'component',
		ReviewForm,
		83,
		2,
		{ componentTag: 'Field' }
	);

	var node_2 = $.sibling(node_1, 2);

	$.add_svelte_meta(
		() => Field(node_2, {
			label: 'Your review',
			name: 'body',
			rows: 4,
			placeholder: 'What did you eat? What should someone order first?',
			get value() {
				return $.get(body);
			},

			set value($$value) {
				$.set(body, $$value, true);
			}
		}),
		'component',
		ReviewForm,
		84,
		2,
		{ componentTag: 'Field' }
	);

	var node_3 = $.sibling(node_2, 2);

	{
		var consequent_1 = ($$anchor) => {
			var p = root_1();
			var text_2 = $.child(p, true);

			$.reset(p);
			$.template_effect(() => $.set_text(text_2, $.get(error)));
			$.append($$anchor, p);
		};

		$.add_svelte_meta(
			() => $.if(node_3, ($$render) => {
				if ($.get(error)) $$render(consequent_1);
			}),
			'if',
			ReviewForm,
			86,
			2
		);
	}

	var div_2 = $.sibling(node_3, 2);
	var button_1 = $.child(div_2);
	var text_3 = $.child(button_1, true);

	$.reset(button_1);

	var node_4 = $.sibling(button_1, 2);

	{
		var consequent_2 = ($$anchor) => {
			var span_1 = root_2();

			$.append($$anchor, span_1);
		};

		$.add_svelte_meta(
			() => $.if(node_4, ($$render) => {
				if (!session.user) $$render(consequent_2);
			}),
			'if',
			ReviewForm,
			92,
			4
		);
	}

	$.reset(div_2);
	$.reset(form);

	$.template_effect(() => {
		$.set_text(text, existing()
			? "Update your review"
			: "Been here? Tell your neighbours");

		$.set_text(text_1, words[$.get(shown)] ?? "");
		button_1.disabled = $.get(busy);

		$.set_text(text_3, $.get(busy)
			? "Posting…"
			: existing() ? "Update review" : "Post review");
	});

	$.event('submit', form, submit);

	$.event('mouseleave', div_1, function mouseleave() {
		return $.set(hovered, 0);
	});

	$.append($$anchor, form);

	return $.pop($$exports);
}

$.delegate(['click']);